import * as universal from "../../../../src/routes/(registration)/auth/+page.ts";
export { universal };